<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Belanja Produk</div>
		</div>

		<template v-if="loading">
			<div class="d-flex flex-wrap mr-n3">
				<v-col cols="6" sm="4" md="3" lg="3" xl="2" class="pl-0 pb-0 col-md-20" v-for="i in 5" :key="i">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow h-100 w-100 custom-skeleton">
						<v-skeleton-loader width="100%" height="140px" type="image" class="rounded-xl"></v-skeleton-loader>
						<v-skeleton-loader width="50%" type="text" class="mt-5"></v-skeleton-loader>
						<v-skeleton-loader width="100%" type="text" class="mt-2"></v-skeleton-loader>
						<v-skeleton-loader width="50%" type="text" class="mt-2"></v-skeleton-loader>
						<v-skeleton-loader width="100%" type="heading" class="mt-3 rounded-xl"></v-skeleton-loader>
					</v-card>
				</v-col>
			</div>
		</template>

		<template v-else>
			<div class="mt-5" v-if="Object.keys(originCompany).length > 0">
				<div :class="zero_step ? 'd-block' : 'd-none'">
					<StepZero ref="stepZero" :paketlist="packageList" @action="getZeroData"></StepZero>
				</div>
				<div :class="first_step ? 'd-block' : 'd-none'">
					<StepSatu ref="stepSatu" :stockist_data="originCompany" :paket="activePaket" @action="getFirstData"></StepSatu>
				</div>
				<div :class="second_step ? 'd-block' : 'd-none'">
					<StepDua :firstData="first_data" :stockist_data="originCompany" :paket="activePaket" @action="getSecondData"></StepDua>
				</div>
				<div :class="third_step ? 'd-block' : 'd-none'">
					<StepTiga :shippingMethod="shipping_method" ref="stepTiga"></StepTiga>
				</div>
			</div>
		</template>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import StepZero from './StepZero';
import StepSatu from './StepSatu';
import StepDua from './StepDua';
import StepTiga from './StepTiga';

export default {
	components: {
		StepZero, StepSatu, StepDua, StepTiga
	},
	data() {
		return {
			loading: false,
			zero_step: true,
			first_step: false,
			second_step: false,
			third_step: false,
			stockist_data: {},
			first_data: [],
			shipping_method: '',
			dataPaket: [
				{
					paket_id: 1,
					paket_name: 'Paket Stockist',
					paket_min_order: 30,
					paket_price: 290000,
					paket_img: require('/public/assets/icon/stockist.png')
				},
				{
					paket_id: 2,
					paket_name: 'Paket Master Stockist',
					paket_min_order: 200,
					paket_price: 280000,
					paket_img: require('/public/assets/icon/master-stockist.png')
				}
			],
			activePaket: {}
		}
	},
	computed: {
		...mapState('transaksiProduk', ['stockistList', 'stockistPagination', 'packageList', 'packagePagination', 'originCompany']),
	},
	methods: {
		...mapActions('transaksiProduk', ['getStockistList', 'getLoadStockistList', 'getPackageList', 'getOriginCompany']),

		getZeroData(paket) {
			this.activePaket = paket
			this.first_step = true
			this.zero_step = false
			this.$refs.stepSatu.getData()
		},
		getFirstData(step, data) {
			if (step == 'back') {
				this.zero_step = true
				this.first_step = false
				this.$refs.stepSatu.getData()
			} else {
				this.first_data = data
				this.first_step = false
				this.second_step = true
				this.$refs.stepSatu.getData()
			}
		},
		getSecondData(step, shipping) {
			if (step == 'back') {
				this.first_step = true
				this.second_step = false
				this.$refs.stepSatu.getData()
			} else if (step == 'next') {
				this.shipping_method = shipping
				this.second_step = false
				this.third_step = true
				// this.$refs.stepTiga.getData()
			}
		},
	},
	async mounted(){
		this.loading = await true
		await this.getOriginCompany()
		this.getPackageList(this.queryString({sort: 'packet_order', dir: 'ASC', limit: 100, page: 1}))
		// await this.getStockistList(this.queryString({sort: 'stockist_member_id', dir: 'ASC', limit: 10, page: 1}))
		// if (this.stockistList.length > 0) {
		// 	this.stockistList.map(x => {
		// 		if (x.stockist_code == 'SB100000001') this.stockist_data = x
		// 	})
		// }

		setTimeout(() => {
			this.loading = false
		}, 1000);
		
		this.$store.dispatch('setPageTitle', `Belanja Produk`)
	},
};
</script>
